"use strict";

module.exports = {
  CHOOSE_CONTAINER_TITLE: 'Your loan will be deposited to the following bank account',
  ERROR_SCREEN_TITLE: 'Whoops!',
  ERROR_SCREEN_MESSAGE: 'There was a problem connecting your bank account. Please try again.',
  ERROR_SCREEN_BUTTON: 'Try Again',
  ERROR_SCREEN_MESSAGE_UNSUPPORTED_ACCOUNTS: 'There was a problem connecting your bank account.',
  ERROR_SCREEN_BUTTON_UNSUPPORTED_ACCOUNTS: 'Try Another Bank Account',
  FIRST_NAME_REQUIRED: 'Your first name is required.',
  LAST_NAME_REQUIRED: 'Your last name is required.',
  ROUTING_NUMBER_REQUIRED: 'Your bank routing number is required.',
  ROUTING_NUMBER_VALID: 'We cannot identify your routing number. Make sure it includes 9 digits without any dashes, spaces or letters.',
  ACCOUNT_REQUIRED: 'Your bank account number is required.',
  ACCOUNT_NUMBER_VALID: 'Please enter your account number using only numbers, without any dashes, spaces or letters.',
  ACCOUNT_NUMBER_LAST_FOUR: 'Please enter the Account Number ending in',
  CONFIRM_ACCOUNT_REQUIRED: 'Please confirm your bank account number.',
  CONFIRM_ACCOUNT_NUMBER_VALID: 'Please enter your account number using only numbers, without any dashes, spaces or letters.',
  CONFIRM_ACCOUNT_NUMBER_LAST_FOUR: 'Please enter the Account Number ending in',
  CONFIRM_ACCOUNT_NUMBER_SHOULD_MATCH_ACCOUNT_NUMBER: 'This number must match your bank account number above.',
  UNSUPPORTED_ACCOUNTS_DISCLAIMER: "Unfortunately, we don\u2019t allow members to link credit cards and other non-standard bank accounts to LendingClub personal loans.",
  RESELECT_DIFFERENT_BANK_LABEL: 'Need to use a different bank account?',
  RESELECT_DIFFERENT_BANK_ANCHOR: 'Change Your Bank'
};
